import {
    CLOSE_ADBAR,
    CloseAdBarAction,
    OPEN_ADBAR,
    OpenAdBarAction,
    TOGGLE_ADBAR,
    ToggleAdBarAction,
} from './types';

export function toggleAdBar(): ToggleAdBarAction {
    return {
        type: TOGGLE_ADBAR,
    };
}

export function openAdBar(): OpenAdBarAction {
    return {
        type: OPEN_ADBAR,
    };
}

export function closeAdBar(): CloseAdBarAction {
    return {
        type: CLOSE_ADBAR,
    };
}
